import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { makeStyles } from '@material-ui/styles';

import { Patient } from '@vestahealthcare/common/models';

import { Colors, IconButton } from 'styleguide-v2';

import { VestaChatContext } from 'dash/src/contexts/VestaChatContext';

import { Channel } from 'stream-chat';

interface Props {
  patient: Patient;
}

const useStyles = makeStyles({
  unreadIndicator: {
    position: 'absolute',
    top: -2,
    right: -2,
    height: 10,
    width: 10,
    backgroundColor: 'red',
    borderRadius: 50,
  },
});

export const ChatButton = ({ patient }: Props) => {
  const history = useHistory();
  const styles = useStyles();
  const [channels, setChannels] = useState<Channel[]>();
  const { chatClient } = useContext(VestaChatContext);

  useEffect(() => {
    const fetchChannelsForMember = async () => {
      const filters = { type: 'messaging', memberId: patient.id };
      const memberChannels = await chatClient?.queryChannels(
        filters,
        {},
        { watch: false },
      );

      setChannels(memberChannels);
    };

    fetchChannelsForMember();
  }, [patient]);

  const hasChannels = channels?.filter((c) => c.data?.memberId === patient.id);
  if (!hasChannels?.length) {
    return null;
  }

  const hasUnreadMessages = hasChannels?.some((c) => c.countUnread() > 0);

  return (
    <IconButton
      onClick={() => history.push(`/chats?memberId=${patient.id}`)}
      data-cy="member-chats-button"
    >
      <i
        className="fa fa-comments video-icon"
        style={{ color: Colors.green }}
      />
      {hasUnreadMessages && <div className={styles.unreadIndicator} />}
    </IconButton>
  );
};

export default ChatButton;
